import { FiltersFormFamily } from 'family/view-models/family-list';
import { HeadCell } from 'shell/components/shared/table/types';
import { FiltersPersonSearch } from 'shell/constants/filters-person-search';
import { regrexOnlyNumberWithoutGlobal } from 'shell/constants/regex';
import { FamilyVM } from 'shell/view-models/family-member';
import { IdentityCardVM, ResidencePermitVM } from 'shell/view-models/search-anpr';
import * as yup from 'yup';

export const validationSchemaFiltersFamily = yup
  .object({
    isMunicipality: yup.boolean(),
    codeAnpr: yup.string().nullable(),
    codeMunicipality: yup.string().nullable(),
    codeIstat: yup.string().nullable(),
    subjectData: yup.object().shape({
      istatCode: yup.string().nullable().min(6, 'Codice istat è di 6 caratteri'),
    }),
    identityCard: yup
      .object()
      .shape({
        number: yup
          .string()
          .nullable()
          .matches(/(^\d{7}[a-zA-z]{2}$)|(^[a-zA-z]{2}\d{5}[a-zA-z]{2}$)|(^[a-zA-z]{2}\d{7}$)/gi, {
            message:
              'Numero carta di identità invalido, deve essere in uno di questi formati: AB0000198, CA00001AA o 1111101AB',
          }),
      })
      .test('identityCard', 'Campo obbligatorio', (values) => {
        const v = values as unknown as IdentityCardVM;
        if (v.consulate && v.municipality) {
          return new yup.ValidationError(
            "Valorizzare consolato o carta d'identità",
            undefined,
            'identityCard.municipality'
          );
        }
        if ((v.consulate || v.municipality) && !v.number) {
          return new yup.ValidationError('Campo obbligatorio', undefined, 'identityCard.number');
        }
        return true;
      }),
    residencePermit: yup
      .object()
      .shape({
        permitNumber: yup.string().nullable(),
      })
      .test('residencePermit', 'Campo obbligatorio', (values) => {
        const v = values as unknown as ResidencePermitVM;
        if (v.passportNumber && (v.permitNumber || v.preccint)) {
          return new yup.ValidationError(
            'Valorizzare permesso soggiorno e questura oppure il numero passporto',
            undefined,
            'residencePermit.permitNumber'
          );
        }
        return true;
      }),
  })
  .test('', '', (values) => {
    const v = values as unknown as FiltersFormFamily;
    const openedAccordion = v?.openedAccordion;

    if (openedAccordion === FiltersPersonSearch.Family || openedAccordion === undefined) {
      if (v?.isMunicipality) {
        if (!v?.codeAnpr) {
          return new yup.ValidationError('Campo obbligatorio', undefined, 'codeAnpr');
        }
      } else {
        const errors: yup.ValidationError[] = [];
        if (!v?.codeMunicipality) {
          errors.push(new yup.ValidationError('Campo obbligatorio', undefined, 'codeMunicipality'));
        }
        if (v?.codeMunicipality) {
          if (!v?.codeIstat) {
            errors.push(new yup.ValidationError('Campo obbligatorio', undefined, 'codeIstat'));
          } else if (v.codeIstat.length < 6) {
            errors.push(
              new yup.ValidationError('Codice istat è di 6 caratteri', undefined, 'codeIstat')
            );
          } else if (!regrexOnlyNumberWithoutGlobal.test(v?.codeIstat)) {
            errors.push(new yup.ValidationError('Campo numerico', undefined, 'codeIstat'));
          }
        }
        if (errors.length > 0) {
          return new yup.ValidationError(errors);
        }
      }
    }

    if (openedAccordion === FiltersPersonSearch.FiscalCode) {
      if (!v?.searchByFiscalCode?.fiscalCode) {
        return new yup.ValidationError(
          'Campo obbligatorio',
          undefined,
          'searchByFiscalCode.fiscalCode'
        );
      }
    }

    if (openedAccordion === FiltersPersonSearch.SubjectData) {
      const subjectErrors: yup.ValidationError[] = [];
      const s = v?.subjectData;
      const hasIdSearch = (s?.municipalityId && s?.istatCode) || s?.anprId;
      if (!s?.name && !s?.withoutName && !hasIdSearch) {
        subjectErrors.push(
          new yup.ValidationError('Campo obbligatorio', undefined, 'subjectData.name')
        );
      }
      if (!s?.surname && !s?.withoutSurname && !hasIdSearch) {
        subjectErrors.push(
          new yup.ValidationError('Campo obbligatorio', undefined, 'subjectData.surname')
        );
      }
      return subjectErrors.length > 0 ? new yup.ValidationError(subjectErrors) : true;
    }

    if (openedAccordion === FiltersPersonSearch.IdentityCard) {
      if (!v?.identityCard?.number) {
        return new yup.ValidationError('Campo obbligatorio', undefined, 'identityCard.number');
      }
    }

    if (openedAccordion === FiltersPersonSearch.ResidencePermit) {
      if (!v?.residencePermit?.permitNumber) {
        return new yup.ValidationError(
          'Campo obbligatorio',
          undefined,
          'residencePermit.permitNumber'
        );
      }
    }

    return true;
  });

export const headCells: HeadCell<FamilyVM, keyof FamilyVM>[] = [
  {
    id: 'fiscalCode',
    label: 'Codice Fiscale',
  },
  {
    id: 'surname',
    label: 'Cognome',
  },
  {
    id: 'name',
    label: 'Nome',
  },
  {
    id: 'gender',
    label: 'Sesso',
  },
  {
    id: 'dateBirth',
    label: 'Data di nascita',
  },
  {
    id: 'placeBirth',
    label: 'Luogo di nascita',
  },
  {
    id: 'residence',
    label: 'Residenza',
  },
  {
    id: 'state',
    label: 'Stato',
  },
  {
    id: 'relationship',
    label: 'Parentela',
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];
